import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import debounce from '@utils/debounce';
import { throttleComplete } from '@utils/throttle';
const initDesignSectionSlider = (element) => {
    const sliderElement = element.querySelector('.design-section__slider');
    if (!sliderElement)
        return;
    // sliderElement.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    //   const preloader = document.createElement('div');
    //   preloader.classList.add('swiper-lazy-preloader');
    //   preloader.classList.add('swiper-lazy-preloader-white');
    //   img.parentNode?.appendChild(preloader);
    // });
    const pagination = (element === null || element === void 0 ? void 0 : element.querySelector('.design-section__pagination')) || null;
    const options = {
        modules: [Pagination, Autoplay, EffectFade],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 700,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
        },
    };
    const autoplayDelay = element.hasAttribute('data-autoplay')
        ? +(element.getAttribute('data-autoplay') || 0)
        : 0;
    if (autoplayDelay) {
        options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        };
    }
    let swiper;
    const initSlider = () => {
        swiper = new Swiper(sliderElement, options);
        sliderElement.swiper = swiper;
    };
    window.addEventListener('resize', debounce(initSlider, 300));
    initSlider();
};
document.querySelectorAll('.design-section__photos').forEach((element) => {
    initDesignSectionSlider(element);
});
const section = document.querySelector('.design-section');
const getScrollTop = () => (document.body.scrollTop || document.documentElement.scrollTop);
const targetSection = document.querySelector('.cta-contacts-section');
const handleScroll = () => {
    if (section && targetSection) {
        const currentScrollTop = getScrollTop();
        const targetPosition = (targetSection === null || targetSection === void 0 ? void 0 : targetSection.getBoundingClientRect().top) || 0;
        const isButtonFixed = (currentScrollTop > section.offsetHeight - 48) && (targetPosition > 100);
        section.classList.toggle('design-section--fix-button', isButtonFixed);
    }
};
window.addEventListener('scroll', throttleComplete(handleScroll, 100));
